(function () {
  'use strict';

  angular.module('popup', ['ui.bootstrap']);
})();
